module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n            Logs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Communications")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('a', {
    ref: "showCommsBtn",
    staticClass: "actionBtn"
  }, [_vm._v("Show")])]), _vm._v(" "), (!_vm.disable_add_entry) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('a', {
    ref: "addCommsBtn",
    staticClass: "actionBtn pull-right",
    on: {
      "click": function($event) {
        return _vm.addComm()
      }
    }
  }, [_vm._v("Add Entry")])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Actions")]), _c('br'), _vm._v(" "), _c('a', {
    ref: "showActionBtn",
    staticClass: "actionBtn",
    attrs: {
      "tabindex": "2"
    }
  }, [_vm._v("Show")])])])])]), _vm._v(" "), _c('AddCommLog', {
    ref: "add_comm",
    attrs: {
      "url": _vm.comms_add_url
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1"
  }, [_c('span', [_vm._v("|")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-620e0e8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/comms_logs.vue
// module id = 992
// module chunks = 0